/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Raifragen } from '../../models/raifragen';

export interface ApiRaifragenPost$Json$Params {
      body?: Raifragen
}

export function apiRaifragenPost$Json(http: HttpClient, rootUrl: string, params?: ApiRaifragenPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
  const rb = new RequestBuilder(rootUrl, apiRaifragenPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Raifragen>;
    })
  );
}

apiRaifragenPost$Json.PATH = '/api/Raifragen';
